export default __webpack_public_path__ + "static/media/users-default.6f663b1b.svg";